/**
 * Base URL for the marketing site (terms, privacy, cookies).
 * Set VITE_MARKETING_URL in .env for non-production (e.g. http://localhost:4321).
 */
const MARKETING_BASE = import.meta.env.VITE_MARKETING_URL || 'https://bizcontent.ai';

export const LEGAL_URLS = {
  terms: `${MARKETING_BASE}/terms`,
  privacy: `${MARKETING_BASE}/privacy`,
  cookies: `${MARKETING_BASE}/cookies`,
} as const;
